import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import * as Yup from "yup";
import { getBranchAirport, getBranchCity, getBranchCountry, getBranchDetail, getBranchSeaport, getBranchState } from '../../../../../Redux/action/Organisation/Branch/BranchAction';
import { adminMainUrl } from '../../../../../Config';
import axios from 'axios';
import Cookies from "js-cookie";
import { toast } from 'react-toastify';

const Address = ({ branch_id, token, user_id, b64id, refresh, EmployeeList, loadingEmployeeList }) => {
    const dispatch = useDispatch();

    const [showLoader, setShowLoader] = useState(false);
    const [isLobWise, setIsLobWise] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);

    useEffect(() => {
        dispatch(getBranchCountry());
        dispatch(getBranchSeaport());
        dispatch(getBranchAirport());
    }, []);


    const {
        loadingBranchCountryApi,
        BranchCountryDataError,
        BranchCountryData,

        //state
        loadingBranchStateApi,
        BranchStateDataError,
        BranchStateData,

        //city
        loadingBranchCityApi,
        BranchCityDataError,
        BranchCityData,

        //sea port
        loadingBranchSeaportApi,
        BranchSeaportDataError,
        BranchSeaportData,

        //air port
        loadingBranchAirportApi,
        BranchAirportDataError,
        BranchAirportData,


        //branch detail
        loadingBranchDetail,
        BranchDetailError,
        BranchDetail,
    } = useSelector(state => state?.BranchReducer);




    const initialValues = {
        customer_id: "",
        branch_name: "",
        branch_gst_no: "",
        is_set_as_default: false,
        is_deactivate: false,
        address_line_one: "",
        address_line_two: "",
        address_line_three: "",
        country: "",
        state_province: "",
        city: "",
        postal_code: "",
        telephone: "",
        fax: "",
        website: "",
        email_address: "",
        is_LOB: 0, // 1=> Yes ,0 => No
        sales_person_id: "",
        collection_exec_id: "",
        taxable_type: "",
        default_loading_discharge_port_for_sea: "",
        default_loading_discharge_port_for_air: "",
        contact_name: "",
        title_designation: "",
        department: "",
        mobile: "",
        email_address_one: "",
        contact_name_two: "",
        title_designation_two: "",
        department_two: "",
        mobile_two: "",
        email_address_two: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({}),
        onSubmit: (values, { resetForm }) => {
            values.customer_id = atob(b64id);
            if (!values.sales_person_id) { values.sales_person_id = null }
            if (!values.collection_exec_id) { values.collection_exec_id = null }
            setDisableSubmit(true);
            try {
                const config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }

                let url = "";

                if (branch_id == 0) {
                    url = `${adminMainUrl}/api/organization/general/branch/add`;
                } else {
                    url = `${adminMainUrl}/api/organization/general/branch/update`;
                    values.id = Number(branch_id);
                }

                axios.post(url, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            setDisableSubmit(false);
                            refresh();
                            resetForm();
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error."
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    });
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    const [employeeOptions, setEmployeeOptions] = useState([]);

    useEffect(() => {
        if (EmployeeList) {
            let arr = [];
            EmployeeList.map((val) => { arr.push({ value: Number(val.user_id), label: val.name }) });
            setEmployeeOptions(arr);
        }
    }, [EmployeeList]);


    // branch id based selection
    // if 0 -> reset form to add new entries.
    // if !=0 -> use dispatch to set details to edit form

    useEffect(() => {
        if (branch_id == 0) {
            formik.resetForm();
        } else {
            dispatch(getBranchDetail(token, user_id, branch_id));
        }
    }, [branch_id]);



    useEffect(() => {

        if (loadingBranchDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (branch_id) {
            if (BranchDetail) {
                //select state based on the country
                if (BranchDetail.country) {
                    handleGetState(Number(BranchDetail?.country))
                }

                if (BranchDetail?.state_province) {
                    handleGetCity(Number(BranchDetail?.state_province))
                }


                formik.setFieldValue("customer_id", BranchDetail?.customer_id)
                formik.setFieldValue("branch_name", BranchDetail?.branch_name)
                formik.setFieldValue("branch_gst_no", BranchDetail?.branch_gst_no)
                formik.setFieldValue("is_set_as_default", BranchDetail?.is_set_as_default)
                formik.setFieldValue("is_deactivate", BranchDetail?.is_deactivate)
                formik.setFieldValue("address_line_one", BranchDetail?.address_line_one)
                formik.setFieldValue("address_line_two", BranchDetail?.address_line_two)
                formik.setFieldValue("address_line_three", BranchDetail?.address_line_three)
                formik.setFieldValue("country", Number(BranchDetail?.country))
                formik.setFieldValue("state_province", Number(BranchDetail?.state_province))
                formik.setFieldValue("city", Number(BranchDetail?.city))
                formik.setFieldValue("postal_code", BranchDetail?.postal_code)
                formik.setFieldValue("telephone", BranchDetail?.telephone)
                formik.setFieldValue("fax", BranchDetail?.fax)
                formik.setFieldValue("website", BranchDetail?.website)
                formik.setFieldValue("email_address", BranchDetail?.email_address)
                formik.setFieldValue("is_LOB", BranchDetail?.is_LOB)
                formik.setFieldValue("sales_person_id", BranchDetail?.sales_person_id)
                formik.setFieldValue("collection_exec_id", BranchDetail?.collection_exec_id)
                formik.setFieldValue("taxable_type", BranchDetail?.taxable_type)
                formik.setFieldValue("default_loading_discharge_port_for_sea", Number(BranchDetail?.default_loading_discharge_port_for_sea))
                formik.setFieldValue("default_loading_discharge_port_for_air", Number(BranchDetail?.default_loading_discharge_port_for_air))
                formik.setFieldValue("contact_name", BranchDetail?.contact_name)
                formik.setFieldValue("title_designation", BranchDetail?.title_designation)
                formik.setFieldValue("department", BranchDetail?.department)
                formik.setFieldValue("mobile", BranchDetail?.mobile)
                formik.setFieldValue("email_address_one", BranchDetail?.email_address_one)
                formik.setFieldValue("contact_name_two", BranchDetail?.contact_name_two)
                formik.setFieldValue("title_designation_two", BranchDetail?.title_designation_two)
                formik.setFieldValue("department_two", BranchDetail?.department_two)
                formik.setFieldValue("mobile_two", BranchDetail?.mobile_two)
                formik.setFieldValue("email_address_two", BranchDetail?.email_address_two)
            }
        } else {
            formik.setFieldValue("customer_id", "")
            formik.setFieldValue("branch_name", "")
            formik.setFieldValue("branch_gst_no", "")
            formik.setFieldValue("is_set_as_default", false)
            formik.setFieldValue("is_deactivate", false)
            formik.setFieldValue("address_line_one", "")
            formik.setFieldValue("address_line_two", "")
            formik.setFieldValue("address_line_three", "")
            formik.setFieldValue("country", "")
            formik.setFieldValue("state_province", "")
            formik.setFieldValue("city", "")
            formik.setFieldValue("postal_code", "")
            formik.setFieldValue("telephone", "")
            formik.setFieldValue("fax", "")
            formik.setFieldValue("website", "")
            formik.setFieldValue("email_address", "")
            formik.setFieldValue("is_LOB", 0)
            formik.setFieldValue("sales_person_id", "")
            formik.setFieldValue("collection_exec_id", "")
            formik.setFieldValue("taxable_type", "")
            formik.setFieldValue("default_loading_discharge_port_for_sea", "")
            formik.setFieldValue("default_loading_discharge_port_for_air", "")
            formik.setFieldValue("contact_name", "")
            formik.setFieldValue("title_designation", "")
            formik.setFieldValue("department", "")
            formik.setFieldValue("mobile", "")
            formik.setFieldValue("email_address_one", "")
            formik.setFieldValue("contact_name_two", "")
            formik.setFieldValue("title_designation_two", "")
            formik.setFieldValue("department_two", "")
            formik.setFieldValue("mobile_two", "")
            formik.setFieldValue("email_address_two", "")
        }

    }, [branch_id, loadingBranchDetail, BranchDetailError, BranchDetail])



    //country
    const [countryOptions, setCountryOptions] = useState([]);
    const [loadCountry, setLoadCountry] = useState(false);
    useEffect(() => {
        if (loadingBranchCountryApi) {
            setLoadCountry(true);
        } else {
            setLoadCountry(false);
        }

        if (BranchCountryData) {
            let arr = [];
            BranchCountryData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setCountryOptions(arr);
        }

    }, [loadingBranchCountryApi, BranchCountryDataError, BranchCountryData]);

    //state
    const handleGetState = (id) => {
        try {
            if (id) {
                dispatch(getBranchState(id));
            }
        } catch (error) {
            console.log("Error in handleGetState function:", error.message);
        }
    };
    const [stateOptions, setStateOptions] = useState([]);
    const [loadState, setLoadState] = useState(false);
    useEffect(() => {
        if (loadingBranchStateApi) {
            setLoadState(true);
        } else {
            setLoadState(false);
        }

        if (BranchStateData) {
            let arr = [];
            BranchStateData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setStateOptions(arr);
        }

    }, [loadingBranchStateApi, BranchStateDataError, BranchStateData]);


    //city
    const handleGetCity = (id) => {
        try {
            if (id) {
                dispatch(getBranchCity(id));
            }
        } catch (error) {
            console.log("Error in handleGetCity function:", error.message);
        }
    };
    const [cityOptions, setCityOptions] = useState([]);
    const [loadCity, setLoadCity] = useState(false);
    useEffect(() => {
        if (loadingBranchCityApi) {
            setLoadCity(true);
        } else {
            setLoadCity(false);
        }

        if (BranchCityData) {
            let arr = [];
            BranchCityData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setCityOptions(arr);
        }

    }, [loadingBranchCityApi, BranchCityDataError, BranchCityData]);


    //air port
    const [airportOptions, setAirportOptions] = useState([]);
    const [loadAirport, setLoadAirport] = useState(false);
    useEffect(() => {
        if (loadingBranchAirportApi) {
            setLoadAirport(true);
        } else {
            setLoadAirport(false);
        }

        if (BranchAirportData) {
            let arr = [];
            BranchAirportData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setAirportOptions(arr);
        }

    }, [loadingBranchAirportApi, BranchAirportDataError, BranchAirportData]);

    //sea port
    const [seaportOptions, setSeaportOptions] = useState([]);
    const [loadSeaport, setLoadSeaport] = useState(false);
    useEffect(() => {
        if (loadingBranchSeaportApi) {
            setLoadSeaport(true);
        } else {
            setLoadSeaport(false);
        }

        if (BranchSeaportData) {
            let arr = [];
            BranchSeaportData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setSeaportOptions(arr);
        }

    }, [loadingBranchSeaportApi, BranchSeaportDataError, BranchSeaportData]);

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };

    return (
        <>
            <h2 className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark accordion-header mb-2">
                <button type="button" aria-expanded="true" className="accordion-button">
                    {" "}
                    <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span>
                    {branch_id ? "Edit" : "Add"} Branch
                </button>
            </h2>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <div className="col-12">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="branch_name" className=" form-label mt-0 mb-0  ">
                                    Branch Name
                                </label>
                                <div className="mb-0 form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="is_set_as_default"
                                        name="is_set_as_default"
                                        checked={formik.values.is_set_as_default}
                                        onChange={(event) =>
                                            formik.setFieldValue("is_set_as_default", event.target.checked)
                                        }
                                    />
                                    <label className=" form-label mt-0 mb-0" htmlFor="is_set_as_default">
                                        Set as Default
                                    </label>
                                </div>
                            </div>
                            <input
                                type="text"
                                maxLength={250}
                                className="form-control form-control-sm"
                                id="name"
                                name="branch_name"
                                placeholder='Enter Branch Name'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.branch_name}
                            />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="name" className=" form-label mt-0 mb-0  ">
                                    Address
                                </label>
                                <div className="mb-0 form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="is_deactivate"
                                        name="is_deactivate"
                                        checked={formik.values.is_deactivate}
                                        onChange={(event) =>
                                            formik.setFieldValue("is_deactivate", event.target.checked)
                                        }
                                    />
                                    <label className=" form-label mt-0 mb-0" htmlFor="is_deactivate">
                                        Deactivate
                                    </label>
                                </div>
                            </div>
                            <div className="mb-1">
                                <input
                                    type="text"
                                    maxLength={250}
                                    className="form-control form-control-sm"
                                    id="address_line_one"
                                    name="address_line_one"
                                    placeholder='Enter Address'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.address_line_one}
                                />

                            </div>
                            <div className="mb-1">
                                <input
                                    type="text"
                                    maxLength={250}
                                    className="form-control form-control-sm"
                                    id="address_line_two"
                                    name="address_line_two"
                                    placeholder='Enter Address line 2'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.address_line_two}
                                />
                            </div>
                            <div className="mb-1">
                                <input
                                    type="text"
                                    maxLength={250}
                                    className="form-control form-control-sm"
                                    id="address_line_three"
                                    name="address_line_three"
                                    placeholder='Enter Address line 3'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.address_line_three}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="country" className=" form-label mt-0 mb-0  ">
                                    Country
                                </label>

                            </div>
                            <Select
                                className='custom-selector'
                                options={countryOptions}
                                styles={customStyles}
                                name="country"
                                value={countryOptions.find(option => option.value === formik.values.country)}
                                onChange={option => { formik.setFieldValue('country', option.value); handleGetState(option.value); formik.setFieldValue('state_province', ''); }}
                                onBlur={formik.handleBlur}
                                isLoading={loadCountry}
                            />

                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="name" className=" form-label mt-0 mb-0  ">
                                    State/Province
                                </label>

                            </div>
                            <Select
                                className='custom-selector'
                                options={stateOptions}
                                styles={customStyles}
                                name="state_province"
                                value={stateOptions.find(option => option.value === formik.values.state_province)}
                                onChange={option => { formik.setFieldValue('state_province', option.value); handleGetCity(option.value); formik.setFieldValue('city', ''); }}
                                onBlur={formik.handleBlur}
                                isLoading={loadState}
                            />

                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="city" className=" form-label mt-0 mb-0  ">
                                    City
                                </label>
                            </div>
                            <Select
                                className='custom-selector'
                                options={cityOptions}
                                styles={customStyles}
                                name="city"
                                value={cityOptions.find(option => option.value === formik.values.city)}
                                onChange={option => formik.setFieldValue('city', option.value)}
                                onBlur={formik.handleBlur}
                                isLoading={loadCity}
                            />

                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="postal_code" className=" form-label mt-0 mb-0  ">
                                    Postal Code
                                </label>
                            </div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="postal_code"
                                minLength={4}
                                maxLength={6}
                                name="postal_code"
                                placeholder='Enter Postal Code'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.postal_code}
                                onInput={(event) => {
                                    let value = event.target.value;
                                    value = value.replace(/[^0-9]/g, '');
                                    if (value.length < 4 && value.length > 0) {
                                        event.target.setCustomValidity('Postal code must be at least 4 characters long.');
                                    } else {
                                        event.target.setCustomValidity('');
                                    }
                                    event.target.value = value;
                                }}
                            />

                        </div>
                    </div>

                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="telephone" className=" form-label mt-0 mb-0  ">
                                    Telephone
                                </label>

                            </div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="telephone"
                                name="telephone"
                                minLength={8}
                                maxLength={15}
                                placeholder='Enter Telephone Number'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.telephone}
                                onInput={(event) => {
                                    let value = event.target.value;
                                    value = value.replace(/[^0-9]/g, '');
                                    event.target.value = value;
                                }}
                            />

                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="fax" className=" form-label mt-0 mb-0  ">
                                    Fax
                                </label>
                            </div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="fax"
                                name="fax"
                                minLength={8}
                                maxLength={15}
                                placeholder='Enter FAX'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.fax}
                                onInput={(event) => {
                                    let value = event.target.value;
                                    value = value.replace(/[^0-9]/g, '');
                                    event.target.value = value;
                                }}
                            />
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="website" className=" form-label mt-0 mb-0  ">
                                    Website
                                </label>
                            </div>
                            <input
                                type="url"
                                className="form-control form-control-sm"
                                id="website"
                                name="website"
                                placeholder='Enter website'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.website}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="email_address" className=" form-label mt-0 mb-0  ">
                                    Email Address
                                </label>

                            </div>
                            <input
                                type="email"
                                className="form-control form-control-sm"
                                id="email_address"
                                name="email_address"
                                maxLength={60}
                                placeholder='Enter Email Address'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email_address}
                            />
                        </div>
                    </div>
                    {/* <div className="col-12">
                        <div className="mb-3">
                            <label htmlFor="branch_name" className=" form-label mt-0 mb-0  ">
                                LOB wise
                            </label>
                            <div className="mb-0 form-check">
                                <input
                                    type="checkbox"
                                    disabled={true}
                                    className="form-check-input"
                                    id="is_LOB"
                                    name="is_LOB"
                                    checked={formik.values.is_LOB}
                                    onChange={(event) => {
                                        if (event.target.checked) {
                                            setIsLobWise(true);
                                        } else {
                                            setIsLobWise(false);
                                        }
                                        return formik.setFieldValue("is_LOB", event.target.checked)
                                    }
                                    }
                                />
                                <label className=" form-label mt-0 mb-0" htmlFor="is_LOB">
                                    LOB wise
                                </label>
                            </div>
                        </div>
                    </div> */}
                    {!isLobWise ?
                        <div className="col-6">
                            <div className="mb-3">
                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="sales_person_id" className=" form-label mt-0 mb-0  ">
                                        Sales Person
                                    </label>
                                </div>
                                {/* <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="sales_person_id"
                                    name="sales_person_id"
                                    placeholder='Enter Sales Person Name'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.sales_person_id}
                                    maxLength={6}
                                /> */}
                                <Select
                                    className='custom-selector'
                                    options={employeeOptions}
                                    styles={customStyles}
                                    name="sales_person_id"
                                    onChange={option => { formik.setFieldValue('sales_person_id', option.value); }}
                                    onBlur={formik.handleBlur}
                                    value={employeeOptions.find(option => option.value === formik.values.sales_person_id)}
                                    isLoading={loadingEmployeeList}
                                />
                            </div>
                        </div>
                        :
                        <>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="air_export_sales_person_id" className=" form-label mt-0 mb-0  ">
                                            Air Export
                                        </label>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="air_export_sales_person_id"
                                        name="air_export_sales_person_id"
                                        placeholder='Enter Sales Person Name'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.air_export_sales_person_id}
                                        maxLength={6}

                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="air_import_sales_person_id" className=" form-label mt-0 mb-0  ">
                                            Air Import
                                        </label>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="air_import_sales_person_id"
                                        name="air_import_sales_person_id"
                                        placeholder='Enter Sales Person Name'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.air_import_sales_person_id}
                                        maxLength={6}

                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="sea_export_sales_person_id" className=" form-label mt-0 mb-0  ">
                                            Sea Export
                                        </label>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="sea_export_sales_person_id"
                                        name="sea_export_sales_person_id"
                                        placeholder='Enter Sales Person Name'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.sea_export_sales_person_id}
                                        maxLength={6}

                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="sea_import_sales_person_id" className=" form-label mt-0 mb-0  ">
                                            Sea Import
                                        </label>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="sea_import_sales_person_id"
                                        name="sea_import_sales_person_id"
                                        placeholder='Enter Sales Person Name'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.sea_import_sales_person_id}
                                        maxLength={6}

                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="land_export_sales_person_id" className=" form-label mt-0 mb-0  ">
                                            Land Export
                                        </label>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="land_export_sales_person_id"
                                        name="land_export_sales_person_id"
                                        placeholder='Enter Sales Person Name'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.land_export_sales_person_id}
                                        maxLength={6}

                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="land_import_sales_person_id" className=" form-label mt-0 mb-0  ">
                                            Land Import
                                        </label>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        id="land_import_sales_person_id"
                                        name="land_import_sales_person_id"
                                        placeholder='Enter Sales Person Name'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.land_import_sales_person_id}
                                        maxLength={6}

                                    />
                                </div>
                            </div>
                        </>
                    }
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="collection_exec_id" className=" form-label mt-0 mb-0  ">
                                    Collection Exec
                                </label>
                            </div>
                            {/* <input
                                type="text"
                                className="form-control form-control-sm"
                                id="collection_exec_id"
                                name="collection_exec_id"
                                placeholder='Enter Collection exec name'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.collection_exec_id}
                                maxLength={6}
                            /> */}
                            <Select
                                className='custom-selector'
                                options={employeeOptions}
                                styles={customStyles}
                                name="collection_exec_id"
                                onChange={option => { formik.setFieldValue('collection_exec_id', option.value); }}
                                onBlur={formik.handleBlur}
                                value={employeeOptions.find(option => option.value === formik.values.collection_exec_id)}
                                isLoading={loadingEmployeeList}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="taxable_type" className=" form-label mt-0 mb-0  ">
                                    Taxable Type
                                </label>
                            </div>
                            <select
                                type="text"
                                className="form-control form-control-sm"
                                id="taxable_type"
                                name="taxable_type"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.taxable_type}
                            >
                                <option value="">-Select a type-</option>
                                <option value="Standard">Standard</option>
                                <option value="SEZ">SEZ</option>
                                <option value="Exempt">Exempt</option>
                                <option value="Composition Supplier">Composition Supplier</option>
                            </select>
                        </div>
                    </div>
                    <hr />
                    <h6>Default Loading/Discharge Port </h6>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="default_loading_discharge_port_for_air" className=" form-label mt-0 mb-0  ">
                                    For air
                                </label>
                            </div>
                            <Select
                                className='custom-selector'
                                options={airportOptions}
                                styles={customStyles}
                                name="default_loading_discharge_port_for_air"
                                value={airportOptions.find(option => option.value === formik.values.default_loading_discharge_port_for_air)}
                                onChange={option => { formik.setFieldValue('default_loading_discharge_port_for_air', option.value) }}
                                onBlur={formik.handleBlur}
                                isLoading={loadAirport}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="default_loading_discharge_port_for_sea" className=" form-label mt-0 mb-0  ">
                                    For sea
                                </label>
                            </div>
                            <Select
                                className='custom-selector'
                                options={seaportOptions}
                                styles={customStyles}
                                name="default_loading_discharge_port_for_sea"
                                value={seaportOptions.find(option => option.value === formik.values.default_loading_discharge_port_for_sea)}
                                onChange={option => { formik.setFieldValue('default_loading_discharge_port_for_sea', option.value) }}
                                onBlur={formik.handleBlur}
                                isLoading={loadAirport}
                            />
                        </div>
                    </div>

                    <hr />
                    <h6>GST details </h6>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="branch_gst_no" className=" form-label mt-0 mb-0  ">
                                    GST No.
                                </label>
                            </div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="branch_gst_no"
                                name="branch_gst_no"
                                maxLength={15}
                                placeholder='Enter GST No. for Branch'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.branch_gst_no}
                            />
                        </div>
                    </div>
                    <hr/>
                    <h6>Contact details </h6>
                    {/* contact person 1 */}
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="contact_name" className=" form-label mt-0 mb-0  ">
                                    Contact Person One Name:
                                </label>
                            </div>
                            <input
                                type="text"
                                maxLength={100}
                                className="form-control form-control-sm"
                                id="contact_name"
                                name="contact_name"
                                placeholder='Enter Name'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.contact_name}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="title_designation" className=" form-label mt-0 mb-0  ">
                                    Contact Person One Designation
                                </label>
                            </div>
                            <input
                                type="text"
                                maxLength={100}
                                className="form-control form-control-sm"
                                id="title_designation"
                                name="title_designation"
                                placeholder='Enter Designation'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.title_designation}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="department" className=" form-label mt-0 mb-0  ">
                                    Contact Person One Department
                                </label>
                            </div>
                            <input
                                type="text"
                                maxLength={100}
                                className="form-control form-control-sm"
                                id="department"
                                name="department"
                                placeholder='Enter Designation'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.department}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="mobile" className=" form-label mt-0 mb-0  ">
                                    Contact Person One Mobile
                                </label>
                            </div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="mobile"
                                name="mobile"
                                minLength={8}
                                maxLength={15}
                                placeholder='Enter Contact Number'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.mobile}
                                onInput={(event) => {
                                    let value = event.target.value;
                                    value = value.replace(/[^0-9]/g, '');
                                    event.target.value = value;
                                }}

                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="email_address_one" className=" form-label mt-0 mb-0  ">
                                    Contact Person One Email
                                </label>
                            </div>
                            <input
                                type="email"
                                maxLength={100}
                                className="form-control form-control-sm"
                                id="email_address_one"
                                name="email_address_one"
                                placeholder='Enter Designation'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email_address_one}
                            />
                        </div>
                    </div>
                    <div className="col-md-6"></div>
                    {/* contact person 2 */}
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="contact_name_two" className=" form-label mt-0 mb-0  ">
                                    Contact Person Two Name:
                                </label>
                            </div>
                            <input
                                type="text"
                                maxLength={100}
                                className="form-control form-control-sm"
                                id="contact_name_two"
                                name="contact_name_two"
                                placeholder='Enter Name'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.contact_name_two}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="title_designation_two" className=" form-label mt-0 mb-0  ">
                                    Contact Person Two Designation
                                </label>
                            </div>
                            <input
                                type="text"
                                maxLength={100}
                                className="form-control form-control-sm"
                                id="title_designation_two"
                                name="title_designation_two"
                                placeholder='Enter Designation'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.title_designation_two}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="department_two" className=" form-label mt-0 mb-0  ">
                                    Contact Person Two Department
                                </label>
                            </div>
                            <input
                                type="text"
                                maxLength={100}
                                className="form-control form-control-sm"
                                id="department_two"
                                name="department_two"
                                placeholder='Enter Designation'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.department_two}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="mobile_two" className=" form-label mt-0 mb-0  ">
                                    Contact Person Two Mobile
                                </label>
                            </div>
                            <input
                                type="text"
                                minLength={8}
                                maxLength={15}
                                className="form-control form-control-sm"
                                id="mobile_two"
                                name="mobile_two"
                                placeholder='Enter Contact Number'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.mobile_two}
                                onInput={(event) => {
                                    let value = event.target.value;
                                    value = value.replace(/[^0-9]/g, '');
                                    event.target.value = value;
                                }}

                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <div className=" mb-1 d-flex justify-content-between align-items-center">
                                <label htmlFor="email_address_two" className=" form-label mt-0 mb-0  ">
                                    Contact Person Two Email
                                </label>
                            </div>
                            <input
                                type="email"
                                maxLength={100}
                                className="form-control form-control-sm"
                                id="email_address_two"
                                name="email_address_two"
                                placeholder='Enter Designation'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.email_address_two}
                            />
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex flex-wrap gap-2">
                    </div>
                    <button className="btn btn-sm btn-danger" type='submit' disabled={disableSubmit} >
                        {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : `${branch_id ? "Update" : "+ Add"} Branch`}
                    </button>
                </div>


            </form>
        </>
    )
}

export default Address